import React from 'react';

var _path;

var SvgReferralCodeMajor = function SvgReferralCodeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 3H3v1H1V2.5A1.5 1.5 0 0 1 2.5 1H4v2zM16.707 6.255a1 1 0 1 0-1.414 1.414l1.293 1.292H12a1 1 0 1 0 0 2h4.586l-1.293 1.293a1 1 0 1 0 1.414 1.414l3-3a1.001 1.001 0 0 0 0-1.415l-3-3v.002zM7 6h2v8H7V6zM19 18a1 1 0 0 1-1 1h-2v-2h1v-1h2v2zM2 19a1 1 0 0 1-1-1v-2h2v1h1v2H2zM17 3v1h2V2.5A1.5 1.5 0 0 0 17.5 1H16v2h1zM5 6H1v8h4V6z"
  })));
};

export { SvgReferralCodeMajor as S };
